import CommandPalette from "./CommandPalette.vue";

export * from "./command.type";
export default CommandPalette;
